import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.prueflauf-loeschen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufLoeschenEffects {

    PrueflaufLoeschen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFLAUF_LOESCHEN),
        mergeMap((x: ac.PostPrueflaufLoeschenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPrueflaufLoeschen(x.prueflaufRequest).pipe(
                map((result: any) => {
                    return new ac.PostPrueflaufLoeschenErfolgreichAction(result, x.prueflaufRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPrueflaufLoeschenFehlerAction(error, x.prueflaufRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufCommandService);
        }
        return this.service;
    }
}
